import { stage } from 'config/stage';

const pinpoint = {
    prd: {
        appId: process.env.REACT_APP_PINPOINT_PROJECT_ID,
        region: 'us-west-2',
    },
    test: {
        appId: process.env.REACT_APP_PINPOINT_PROJECT_ID,
        region: 'us-west-2',
    },
    dev: {
        appId: process.env.REACT_APP_PINPOINT_PROJECT_ID,
        region: 'us-west-2',
    },
    cloud9: {
        appId: process.env.REACT_APP_PINPOINT_PROJECT_ID,
        region: 'us-west-2',
    },
    ide: {
        appId: process.env.REACT_APP_PINPOINT_PROJECT_ID,
        region: 'us-west-2',
    },
};

let analytics = {
    // OPTIONAL - disable Analytics if true
    disabled: true,
    // OPTIONAL - Allow recording session events. Default is true.
    autoSessionRecord: true,

    AWSPinpoint: {
        // OPTIONAL -  Amazon Pinpoint App Client ID
        appId: pinpoint[stage].appId,
        // OPTIONAL -  Amazon service region
        region: pinpoint[stage].region,

        endpoint: {
            userAttributes: {},
        },

        // Buffer settings used for reporting analytics events.
        // OPTIONAL - The buffer size for events in number of items.
        bufferSize: 1000,

        // OPTIONAL - The interval in milliseconds to perform a buffer check and flush if necessary.
        flushInterval: 5000, // 5s

        // OPTIONAL - The number of events to be deleted from the buffer when flushed.
        flushSize: 100,

        // OPTIONAL - The limit for failed recording retries.
        resendLimit: 5,
    },
};

export default analytics;
